import { render, staticRenderFns } from "./ShoppingBagIcon.vue?vue&type=template&id=3a492d9d"
import script from "./ShoppingBagIcon.vue?vue&type=script&lang=js"
export * from "./ShoppingBagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports